import React, { useState } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme'; // ← your existing MUI theme import; adjust path if different

import SmoothScrollProvider from './components/SmoothScrollProvider';
import CustomCursor from './components/CustomCursor';
import Preloader from './components/Preloader';
import AmbientField from './three/AmbientField';

import NavBar from './components/NavBar';
import Home from './components/Home';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Certifications from './components/Certifications';
import Footer from './components/Footer';

/**
 * Drop-in App.js showing how all the new motion/3D pieces wire together
 * around your existing sections. Merge this with your real App.js —
 * the important parts are:
 *   1. Preloader renders on top of everything until it finishes.
 *   2. SmoothScrollProvider wraps the whole page (drives Lenis + GSAP).
 *   3. CustomCursor + AmbientField are rendered once, globally.
 *   4. Your existing sections (NavBar, Home, Experience, ...) are untouched.
 */
export default function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {!loaded && <Preloader onComplete={() => setLoaded(true)} />}

      <SmoothScrollProvider>
        <CustomCursor />
        <AmbientField />

        <NavBar />
        <main style={{ position: 'relative', zIndex: 1 }}>
          <Home />
          <Experience />
          <Projects />
          <Skills />
          <Certifications />
        </main>
        <Footer />
      </SmoothScrollProvider>
    </ThemeProvider>
  );
}
